const ProductRoutes = {
  getProducts: 'marketplace/products',
  getProductDetails: 'marketplace/products/details/',
};

export default ProductRoutes